export default __webpack_public_path__ + "static/media/chevron-right.bb45eea6.svg";